var _a;
import { DocumentTypeEnum, DriveEventActionEnum, DriveEventSubActionEnum } from '@workalizer/shared';
var DOCUMENT_TYPE_LABEL_KEYS = (_a = {},
    _a[DocumentTypeEnum.DOCUMENT] = 'app.driveAdvancedSearch.filters.documentTypes.document',
    _a[DocumentTypeEnum.SPREADSHEET] = 'app.driveAdvancedSearch.filters.documentTypes.spreadsheet',
    _a[DocumentTypeEnum.PRESENTATION] = 'app.driveAdvancedSearch.filters.documentTypes.presentation',
    _a);
export var getDocumentTypeLabelKey = function (type) {
    var _a;
    return (_a = DOCUMENT_TYPE_LABEL_KEYS[type]) !== null && _a !== void 0 ? _a : 'app.driveAdvancedSearch.filters.documentTypes.other';
};
export var getDriveDocumentActionFilterOptions = function (t) { return [
    {
        id: null,
        action: null,
        name: t('app.driveAdvancedSearch.filters.actionTypes.any')
    },
    {
        id: DriveEventActionEnum.DOCUMENT_CREATE,
        action: DriveEventActionEnum.DOCUMENT_CREATE,
        name: t('app.driveAdvancedSearch.filters.actionTypes.create')
    },
    {
        id: DriveEventActionEnum.DOCUMENT_EDIT,
        action: DriveEventActionEnum.DOCUMENT_EDIT,
        name: t('app.driveAdvancedSearch.filters.actionTypes.edit')
    },
    {
        id: DriveEventActionEnum.DOCUMENT_UPLOAD,
        action: DriveEventActionEnum.DOCUMENT_UPLOAD,
        name: t('app.driveAdvancedSearch.filters.actionTypes.upload')
    },
    {
        id: DriveEventActionEnum.DOCUMENT_VIEW,
        action: DriveEventActionEnum.DOCUMENT_VIEW,
        name: t('app.driveAdvancedSearch.filters.actionTypes.view')
    },
    {
        id: DriveEventActionEnum.DOCUMENT_PRINT,
        action: DriveEventActionEnum.DOCUMENT_PRINT,
        name: t('app.driveAdvancedSearch.filters.actionTypes.print')
    },
    {
        id: DriveEventActionEnum.DOCUMENT_DOWNLOAD,
        action: DriveEventActionEnum.DOCUMENT_DOWNLOAD,
        name: t('app.driveAdvancedSearch.filters.actionTypes.download')
    },
    {
        id: DriveEventActionEnum.DOCUMENT_CREATE_COMMENT,
        action: DriveEventActionEnum.DOCUMENT_CREATE_COMMENT,
        name: t('app.driveAdvancedSearch.filters.actionTypes.commentPostResolve')
    },
    {
        id: DriveEventActionEnum.DOCUMENT_CREATE_SUGGESTION,
        action: DriveEventActionEnum.DOCUMENT_CREATE_SUGGESTION,
        name: t('app.driveAdvancedSearch.filters.actionTypes.suggestionPostResolve')
    },
    {
        id: DriveEventActionEnum.DOCUMENT_APPROVAL_REQUESTED,
        action: DriveEventActionEnum.DOCUMENT_APPROVAL_REQUESTED,
        name: t('app.driveAdvancedSearch.filters.actionTypes.approvalRequest')
    },
    {
        id: "".concat(DriveEventActionEnum.DOCUMENT_SHARE, "-").concat(DriveEventSubActionEnum.DOCUMENT_SHARED_INTERNALLY),
        action: DriveEventActionEnum.DOCUMENT_SHARE,
        subAction: DriveEventSubActionEnum.DOCUMENT_SHARED_INTERNALLY,
        name: t('app.driveAdvancedSearch.filters.actionTypes.shareInternally')
    },
    {
        id: "".concat(DriveEventActionEnum.DOCUMENT_SHARE, "-").concat(DriveEventSubActionEnum.DOCUMENT_SHARED_EXTERNALLY),
        action: DriveEventActionEnum.DOCUMENT_SHARE,
        subAction: DriveEventSubActionEnum.DOCUMENT_SHARED_EXTERNALLY,
        name: t('app.driveAdvancedSearch.filters.actionTypes.shareExternally')
    },
    {
        id: DriveEventActionEnum.DOCUMENT_PUBLISH,
        action: DriveEventActionEnum.DOCUMENT_PUBLISH,
        name: t('app.driveAdvancedSearch.filters.actionTypes.publish')
    }
]; };
export var findDriveDocumentActionFilterOption = function (options, action, subAction) {
    var _a;
    return (_a = options.find(function (option) {
        if (option.action === null) {
            return !action && !subAction;
        }
        if (option.subAction) {
            return subAction === option.subAction && action === option.action;
        }
        return action === option.action && !subAction;
    })) !== null && _a !== void 0 ? _a : null;
};
